// extracted by mini-css-extract-plugin
export default {"page":"OX-z","cartModal":"PX-z","checkout":"QX-z","placeholder":"RX-z","account":"SX-z"};